import template from './usersBrandAdminForm.html';
import './usersBrandAdminForm.scss';

export class UsersBrandAdminFormController {
  save() {
    this.onSave({
      brands: this.brands,
    });
  }
  searchBrands(text) {
    this.onBrandsSearch({ text });
  }
  toggleBrandSelection(item, isSelected) {
    if (isSelected) {
      const index = this.brands.findIndex((brand) => brand.id === item.id);
      if (index > -1) {
        this.brands.splice(index, 1);
      }
    } else {
      this.brands.push(item);
    }
  }
}

export default {
  controller: UsersBrandAdminFormController,
  template,
  bindings: {
    loading: '<',
    onCancel: '&',
    onSave: '&',

    brands: '<',
    loadingBrands: '<',
    brandsResults: '<',
    onBrandsSearch: '&',
  },
};
